module.exports = __webpack_public_path__ + "img/Weapon_32.9f1e9aec.png";